<!--
 * @Author: your name
 * @Date: 2020-12-23 16:18:50
 * @LastEditTime: 2021-04-09 17:45:40
 * @LastEditors: Please set LastEditors
 * @Description: 验证码组件
 * @FilePath: /hsylc2021/src/components/form/VerificationMsg/verificationMsg.vue
-->
<template>
  <div class="component-verificaMsg ">
    <CheckInput class="veriific-input" type="vecifi" label="验证码" v-model="value" @input="handleInputMsg" />
    <Button class="veriific-btn" skin="grey" @click="sendMsgHandler" :disabled="isCountDown ? true : false">{{
      isCountDown ? time + 's' : '发送验证码'
    }}</Button>
    <!-- 计算验证弹窗 -->
    <Modal v-if="modal" @close="closePostHandler" :overlay="opaque">
      <Card class="content-card">
        <div>{{ verificationMsg }} =</div>
        <CheckInput class="card-input" placeholder="" label="?" type="Number" :startVerific="true" v-model="verificationAnswer" @blur="handleInputBlur" />
        <Button class="card-btn" skin="red" @click="handleSubmitAnswer"> 确认 </Button>
      </Card>
    </Modal>
  </div>
</template>
<script>
import Button from '../Button';
import CheckInput from '../CheckInput/checkInput';
import Modal from '../../Modal';
import Card from '../../Card/card';
import { Api, Codes } from '../../../api';
import { Message } from 'element-ui';
import UTILS from '../../../utils/checkers';
/**
 * 验证码组件
 * @module VerificationMsg
 */
export default {
  name: 'VerificationMsg',
  /**
   * @prop {String} areaCode 区号
   * @prop {String} phone 电话
   * @prop {Number} timeval 倒计时
   */
  props: {
    areaCode: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    timeval: {
      type: Number,
      default: 60
    }
  },
  /**
   * @prop {Component} CheckInput 带验证的输入框组件
   * @prop {Component} Button 按钮组件
   * @prop {Component} Modal 弹窗组件
   * @prop {Component} Card 验证码卡片组件
   */
  components: {
    CheckInput,
    Button,
    Modal,
    Card
  },
  /**
   * @prop {Boolean} opaque
   * @prop {String} value
   * @prop {Boolean} modal 遮罩开关
   * @prop {String} verificationMsg 计算 题目
   * @prop {String} verificationAnswer 计算题答案
   * @prop {Number} time 倒计时时间
   * @prop {Boolean} isCountDown 是否倒计时状态
   */
  data() {
    return {
      opaque: true,
      value: '',
      modal: false, // 遮罩层 开关
      verificationMsg: '', // 计算文字
      verificationAnswer: '', // 计算题答案
      verificationAnswerError: '', // 计算题答案 状态

      time: this.timeval,
      isCountDown: false,
      isSubmit: false // 确认 发送 点击开关 防止重复发送
    };
  },
  mounted() {},
  methods: {
    /**
     * @description 关闭遮罩
     * @function closePostHandler
     */
    closePostHandler() {
      this.isSubmit = false;
      this.modal = false;
      this.verificationAnswer = '';
    },
    handleInputBlur(error) {
      this.verificationAnswerError = error;
    },
    /**
     * @description 发送验证码 点击
     * @function sendMsgHandler
     */
    async sendMsgHandler() {
      if (!this.phone) {
        this.$message.error('请填写手机号');
        return;
      }
      // console.log(UTILS.checkMobile(this.phone));
      if (!UTILS.checkNumber(this.phone)) {
        Message({
          type: 'error',
          message: '手机格式错误'
        });
        return;
      }
      let parm = {
        phone_code: this.areaCode.substr(1),
        phone: this.phone
      };
      let res = await Api.post.validationDown(parm);
      if (res.status !== Codes.SUCCESS) return;
      this.verificationMsg = res.data.code;
      // console.log(res);
      this.time = this.timeval;
      this.modal = true;
    },
    /**
     * @description 倒计时
     * @function timeCountDown
     */
    timeCountDown() {
      const that = this;
      let interval = setInterval(() => {
        that.time--;
        if (that.time <= 0) {
          this.isCountDown = false;
          clearInterval(interval);
        }
      }, 1000);
    },
    /**
     * @description 提交 计算题 答案
     * @function handleSubmitAnswer
     */
    async handleSubmitAnswer() {
      if (this.verificationAnswerError) return;
      if (this.isSubmit) return;
      this.isSubmit = true;
      let parm = {
        phone_code: this.areaCode.substr(1),
        phone: this.phone,
        code: Number(this.verificationAnswer)
      };
      let res = await Api.post.validationUp(parm);
      if (res.status !== Codes.SUCCESS) {
        // 验证失败 刷新题目
        this.sendMsgHandler();
        this.verificationAnswer = '';
        setTimeout(() => {
          this.isSubmit = false;
        }, 3000);

        return;
      }
      // console.log('答题成功：', res);
      // 关闭遮罩
      this.closePostHandler();
      // 开始倒计时
      this.isCountDown = true;
      this.timeCountDown();
    },
    /**
     * @event input 暴漏input
     */
    /**
     * @description 输入验证码
     * @function handleInputMsg
     * @param {Object} e 事件对象
     */
    handleInputMsg(e) {
      this.$emit('input', e);
    }
  }
};
</script>
<style lang="less" src="./verificationMsg.less" scoped></style>
